import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Fa from 'react-icons/fa';

import { Client, Connect, Vendor } from 'services/action';

import { Card } from 'ui/components';
import LogoWhite from 'ui/assets/logos.png';
import { formatDate } from 'utilities/common';

const ConnectScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const StateAuth = useSelector((state) => state.Auth);

  const [data, setData] = React.useState(null);
  const [client, setClient] = React.useState(null);

  const $onLoad = async (id) => {
    const req = await Dispatch(Vendor.$show(id));
    if (req?.message === 'success') {
      setData(req?.data);

      if (req?.data?.client_id) {
        const res = await Dispatch(Client.$show(req?.data?.client_id));
        if (res?.message === 'success') {
          setClient(res?.data);
        }
      }
    }
  };

  const $onConnect = async () => {
    const payload = {
      partner_id: match?.params?.id,
    };

    const req = await Dispatch(Connect.$confirm(payload));

    if (req?.message === 'success') {
      Dispatch(Connect.$save(''));
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <div className="markdown row p-0">
      <div className="col-lg-3 signin d-none d-lg-block"></div>
      <div
        className="col-lg-9 d-flex flex-column justify-content-center align-items-center mt-md-n5"
        style={{ minHeight: '100vh' }}
      >
        <div className="mb-3 text-center ">
          <div className="page-title">Connect Request</div>
        </div>

        <Card className="p-2 login">
          {data?.partner_id !== '' ? (
            <div>
              <div className="text-center fs-6 fw-semibold text-uppercase text-danger">
                Link sudah terkoneksi
              </div>

              <div className="form-footer">
                <button
                  type="button"
                  disabled={StateForm?.loading}
                  className="btn btn-primary w-100 py-3"
                  onClick={() => Dispatch(Connect.$save(''))}
                >
                  {!StateForm?.loading ? (
                    'Kembali ke Beranda'
                  ) : (
                    <div className="spinner-border" role="status"></div>
                  )}
                </button>
              </div>
            </div>
          ) : (
            <div>
              <div className="row justify-content-center align-items-center position-relative">
                <div
                  className="position-absolute px-5"
                  style={{ zIndex: 3, marginTop: -10 }}
                >
                  <div
                    style={{
                      borderTopStyle: 'dotted',
                      borderTopWidth: 5,
                      height: 5,
                      borderColor: '#dedede',
                    }}
                  />
                </div>
                <div
                  className="col-5 text-center d-flex justify-content-center align-items-center flex-column"
                  style={{ zIndex: 4 }}
                >
                  <div>
                    <div className="border border-1 border-primary rounded-pill ">
                      <img
                        src={client?.avatar || LogoWhite}
                        alt=""
                        className="img-fluid rounded-pill"
                        style={{ width: 100, height: 100 }}
                        id="logo-operator"
                      />
                    </div>
                  </div>
                  {client?.name}
                </div>
                <div className="col-2 text-center " style={{ zIndex: 4 }}>
                  <Fa.FaRegCheckCircle
                    size={40}
                    color="#2fb344"
                    className="mt-n3 bg-white"
                  />
                </div>
                <div
                  className="col-5 text-center d-flex justify-content-center align-items-center flex-column"
                  style={{ zIndex: 4 }}
                >
                  <div>
                    <div className="border border-1 border-primary rounded-pill ">
                      <img
                        src={StateAuth?.session?.user?.avatar || LogoWhite}
                        alt=""
                        className="img-fluid rounded-pill"
                        style={{ width: 100, height: 100 }}
                        id="logo-operator"
                      />
                    </div>
                  </div>
                  {StateAuth?.session?.user?.name}
                </div>
              </div>

              <div className="px-3 mt-4">
                <div className="text-center fs-6 fw-semibold text-uppercase text-secondary">
                  {client?.name}
                </div>
                <div className="text-center fs-6 fw-semibold text-secondary">
                  hubungkan dengan client Anda
                </div>

                <div className="form-footer d-flex flex-row gap-2 justify-content-center align-items-center">
                  <div className="col-6">
                    <button
                      type="button"
                      disabled={StateForm?.loading}
                      className="btn btn-light w-100 py-2"
                      onClick={() => Dispatch(Connect.$save(''))}
                    >
                      Tolak
                    </button>
                  </div>

                  <div className="col-6">
                    <button
                      type="button"
                      disabled={StateForm?.loading}
                      className="btn btn-primary w-100 py-2"
                      onClick={$onConnect}
                    >
                      {!StateForm?.loading ? (
                        'Koneksikan'
                      ) : (
                        <div className="spinner-border" role="status"></div>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Card>
        <small className="text-muted mt-3">
          &copy; {formatDate(new Date(), 'YYYY')} envio.co.id
        </small>
      </div>
    </div>
  );
};

export default ConnectScreen;
